import { render } from "./InsuranceGeneral.vue?vue&type=template&id=bb9d5b06"
import script from "./InsuranceGeneral.vue?vue&type=script&lang=js"
export * from "./InsuranceGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__